import React, { useEffect, useState } from 'react';
import '../campaign/CampaignList.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { stampCampaignListBreads } from '../../../config/CustomBreadConfig';
import { getHashKeyString, createAction,ArrayStringData } from '../../../utils';
import {
  URLFragments,
  URLFilterKeys,
} from '../../../components/campaign/CampaignUrlConfig';
import {
  DELETE_RELATED_SECTIONS,
  ActionType,
  PublishTagType,
} from '../../../config/CustomEnums';
import DateRangeSelection from '../../../components/dashboard/DateRangeSelection';
import DateRangeCompare from '../../../components/dashboard/DateRangeCompare';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import BaseTabListContainer from '../../base/BaseTabListContainer';
import BaseListContainer from '../../base/BaseListContainer';
import DeleteCampaignPrompt from '../../../components/campaign/campaignList/DeleteCamapignPrompt';
import BasePrompt from '../../../components/base/prompt/BasePrompt';
import Filter from '../campaign/Filter';
import StampCampaignOverviewTab from '../../../components/stampCampaign/stampCampaignList/StampCampaignOverviewTab';
import { NavBarNames } from 'config/NavBarNameList';

function StampCampaignList() {
  const dispatch = useDispatch();
  const [showPrompt, setShowPrompt] = useState(false);
  const history = useHistory();
  const location = useLocation();
  // const activeTab = getHashKeyString(location.hash) || URLFragments.overview;
  const parsedSearch = queryString.parse(location.search);
  const searchBrand = parsedSearch['brand'] || '';
  const {
    listFields,
    dataList,
    pageInfo,
    totalPage,
    totalCount,
    isSuperuser,
    userPermissions,
    hasDashboardPermission,
    resume,
    brandList,
    checkedBrandList,
  } = useSelector((state) => ({
    listFields: state.campaignList.listFields,
    dataList: state.campaignList.pagedList,
    pageInfo: state.campaignList.pageInfo,
    totalPage: state.campaignList.totalPage,
    totalCount: state.campaignList.totalCount,
    checkedList: state.campaignList.checkedList,
    isSuperuser: state.users.isSuperuser,
    userPermissions: state.users.userPermissions,
    hasDashboardPermission: state.users.hasDashboardPermission,
    resume: state.campaignList.resume,
    brandList: state.brand.brandList,
    checkedBrandList: state.brand.checkedList,
  }));

  const campaignPermission = isSuperuser || userPermissions?.filter(
      (val) => val.split('_')[1] === PermissionCodes.campaign,
    ).length > 0;
  const activeTab = getHashKeyString(location.hash) || (hasDashboardPermission ? URLFragments.overview : URLFragments.list);

  const getFilterMapFromUrl = () => {
    const querySearch = queryString.parse(location.search);
    const searchKey = queryString.parse(location.search)[
      URLFilterKeys.searchKey
    ];
    const stringRank = queryString.parse(location.search)[URLFilterKeys.rank];
    const stringPage =
      queryString.parse(location.search)[URLFilterKeys.page] || 1;
    const rank = stringRank === 'false';
    const page = parseInt(stringPage);
    return {
      ...querySearch,
      page: page,
      reverse: !rank,
      searchKey: searchKey,
    };
  };

  const getList = () => {
    const data = getFilterMapFromUrl();
    dispatch(
      createAction('campaignList/getCampaignList')({ ...data, isStamp: true }),
    );
  };

  useEffect(() => {
    if (!campaignPermission) { return };
    if (activeTab === URLFragments.list) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, location, campaignPermission]);

  useEffect(() => {
    if (!campaignPermission) { return };
    dispatch({ type: 'campaignList/campaignResume', payload: { isStamp: true } });
    dispatch(
      createAction('segments/getAllList')({
        type: 'all',
        isSelectorLoad: true,
        moreSearch: {
          isBlacklist: false,
        }
      }),
    );
    dispatch(createAction('levels/getLevelList')());

    dispatch(createAction('brand/getCurrentPageBrands')({
      moreSearch: {
        brandIds: searchBrand
      },
      isSimpleNode: true,
      noLoading: true,
    }));

    return () => {
      dispatch({ type: 'campaignList/clearData' });
      dispatch(createAction('brand/updateState')({
        checkedList: []
      }))
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignPermission]);

  const getSearchBrand = () => {
    let checkedBrands = []
    const searchBrandList = ArrayStringData(searchBrand)
    searchBrandList.forEach((item, index) => {
      const checkedBrand = brandList.find(value => value?.pk === item)
      if (checkedBrand) {
        checkedBrands.push({
          label: `[ID: ${checkedBrand?.pk}] ${checkedBrand?.name}`,
          value: checkedBrand
        })
      }
    })
    dispatch(createAction('brand/updateState')({
      checkedList: checkedBrands
    }))
  }

  useEffect(()=>{
    if (!campaignPermission) { return };
    if ( searchBrand && brandList?.length > 0 && checkedBrandList?.length === 0 ) {
      getSearchBrand()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandList, campaignPermission])

  useEffect(()=>{
    if (!campaignPermission) { return };
    getSearchBrand()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBrand, campaignPermission])

  const getButton = (name, className, resume) => {
    return (
      <AuthButton
        title={name}
        className={className}
        action={() => {
          dispatch({ type: 'createCampaign/clearData' });
          history.push({
            pathname: '/stamp_campaigns/create',
            state: { resume },
          });
        }}
        requires={PermissionCodes.addCampaign}
      />
    );
  };

  const buttons = [getButton('Create Stamp campaign', 'btn-further', false)];

  if (resume?.showResumeButton) {
    buttons.unshift(
      getButton('Resume', 'campaign-resume-button btn-further', true),
    );
  }

  const groupActions = [
    {
      name: 'Delete',
      action: (campaign) => setShowPrompt(true),
      requires: PermissionCodes.deleteCampaign,
    },
  ];

  const tabs = [
    hasDashboardPermission ? {
      name: URLFragments.overview,
      content: <StampCampaignOverviewTab />,
    } : {},
    isSuperuser ||
    userPermissions?.filter(
      (val) => val.split('_')[1] === PermissionCodes.campaign,
    ).length > 0
      ? {
          name: URLFragments.list,
          content: (
            <BaseTabListContainer
              hideTab={true}
              maxTabWidth={400}
              groupActions={groupActions}
              pageInfo={pageInfo}
              totalCount={totalCount}
              filter={{
                hasFilter: true,
                component: Filter,
                displayIn: 'STAMP_LIST'
              }}
              listContent={
                <BaseListContainer
                  fields={listFields}
                  dataList={dataList}
                  totalPage={totalPage}
                  model={'campaignList'}
                  actions={['Detail', 'Edit', 'Duplicate', 'Delete']}
                  permissionGroup={PermissionCodes.campaign}
                  deleteInfo={{
                    data: [],
                    title: 'Stamp campaign',
                    relatedName: '',
                    onComfirm: {},
                    relatedSections: DELETE_RELATED_SECTIONS.CAMPAIGN,
                  }}
                  hasOtherActions={true}
                  customActions={{
                    custom: (item) => {
                      if (item.displayStatus === PublishTagType.published) {
                        return {
                          name: 'UnPublish',
                          action: (value) => {
                            dispatch(
                              createAction(`createCampaign/updateApprovalStatus`)({
                                actionType: ActionType.unpublish,
                                data: {
                                  pk: value?.pk
                                },
                                afterAction: () => getList()
                              }),
                            );
                          },
                          requires: [
                            PermissionCodes.withdrawPublishCampaignToPending,
                            PermissionCodes.withdrawPublishCampaignToDraft,
                          ],
                          isOnlyNeedOnePermission: true
                        }
                      }
                      return null
                    },
                  }}
                />
              }
            />
          ),
        }
      : {},
  ];

  const hideResumePop = (hide) => {
    dispatch({
      type: 'campaignList/resumeAction',
      payload: { hideResumePop: hide },
    });
  };

  return (
    <>
      <CustomListComponent
        caution={{
          detail: 'Stamp campaign list , should edit with the following',
          title: NavBarNames.stampCampaigns,
        }}
        onTabChange={(key) => {
          let search = '';
          if (key !== URLFragments.overview) {
            search = queryString.stringify({
              [URLFilterKeys.page]: 1,
              [URLFilterKeys.searchKey]: '',
              [URLFilterKeys.rank]: true,
            });
          }
          history.push({
            pathname: '/stamp_campaigns',
            hash: key,
            search: search,
          });
        }}
        defaultActiveKey={activeTab}
        breadcrumb={
          <CustomBreadcrumb breadcrumbs={stampCampaignListBreads()} />
        }
        buttons={buttons}
        renderCompare={() => {
          return activeTab === URLFragments.overview ? (
            <DateRangeCompare />
          ) : null;
        }}
        renderTabsRight={() => {
          return activeTab === URLFragments.overview ? (
            <DateRangeSelection
              onTab
              applyDateRangeEvent={(startDate, endDate) => {
                dispatch(
                  createAction('overview/getStampCampaignsData')({
                    startDate: startDate.format('YYYY-MM-DD'),
                    endDate: endDate.format('YYYY-MM-DD'),
                  }),
                );
              }}
              clearDataEvent={() => {
                dispatch(createAction('overview/clearState')());
              }}
            />
          ) : null;
        }}
        tabs={tabs}
      />
      <DeleteCampaignPrompt
        show={showPrompt}
        onClose={() => setShowPrompt(false)}
        onConfirm={() => {
          setShowPrompt(false);
          dispatch(
            createAction('createCampaign/deleteCampaigns')({
              afterAction: () => {
                history.push(location);
              },
            }),
          );
        }}
      />
      <BasePrompt
        show={resume?.showResumePop}
        closeAction={() => hideResumePop(false)}
        rightButton={{
          text: 'Resume',
          action: () => {
            hideResumePop(false);
            history.push({
              pathname: '/stamp_campaigns/create',
              state: { resume: true },
            });
          },
        }}
        leftButton={{
          text: `Dismiss and don't remind me again`,
          action: () => hideResumePop(true),
        }}
        title={'You have unfinished campaign '}
        description={`You have unfinished campaign before. You can resume it by click “Resume” button at the top of the page`}
      />
    </>
  );
}

export default StampCampaignList;
